<template>
  <div class="h-full relative">
    <div
      v-if="isVisible"
      class="absolute h-full w-full flex flex-wrap top-0 left-0 overflow-hidden z-40"
    >
      <div class="w-full h-full lg:w-1/2 lg:shadow-lg background-variable">
        <project-process
          :process="process"
          :processInfo="processInfo"
          :project="project"
          @info-show="infoShow"
        ></project-process>
      </div>
      <div class="w-1/2 opacity-60 background-variable">
        <div class="w-full h-full opacity-20 background-variable"></div>
      </div>
    </div>
    <div
      v-if="projectsVisible"
      class="fixed h-full w-full flex flex-wrap top-0 left-0 overflow-hidden z-50 pointer-events-auto"
    >
      <div class="w-full md:w-1/2 md:shadow-2xl background-variable h-full">
        <div class="flex justify-between mx-12 mt-4">
          <p :class="['text-6xl', projectsVisible ? 'invisible' : '']">NJ</p>
          <div @click="infoProjects" class="flex justify-end cursor-pointer">
            <Icon icon="iwwa:close" width="55px" weight="light" />
          </div>
        </div>
        <div class="flex flex-col pt-12 px-8">
          <div
            v-for="(item, index) in items"
            :key="index"
            class="md:flex items-end gap-2"
            @mouseover="showImage(index)"
            @mouseleave="hideImage"
          >
            <router-link :to="item.url">
              <p class="text-3xl hover:underline">
                {{ item.title }}
              </p></router-link
            >
            <p class="text-xl text-gray-400 pb-3 md:pb-0">
              {{ $t(item.subtitle) }}
            </p>
          </div>
        </div>
      </div>
      <div class="hidden md:block h-full w-1/2">
        <div v-if="hoveredIndex !== null" class="h-full">
          <img
            :src="getImageUrl(hoveredIndex)"
            alt="Hovered Image"
            class="h-full w-full"
          />
        </div>
        <div v-else class="opacity-50 h-full w-full background-variable"></div>
      </div>
    </div>
    <div class="flex flex-col h-full justify-between">
      <div class="flex justify-between">
        <div class="lg:flex items-end p-4">
          <p class="text-3xl z-30 cursor-pointer" @click="infoProjects">
            L'anomala
          </p>
          <p class="text-xl text-gray-400 lg:pl-1">
            {{ $t("developerInteractive") }}
          </p>
        </div>
      </div>
      <div class="z-30">
        <p class="cursor-pointer text-3xl p-5 max-w-max" @click="processShow">
          {{ $t("process") }}
        </p>
      </div>
    </div>

    <slider-projects :slides="slides" />
  </div>
</template>

<script>
import SliderProjects from "@/components/SliderProjects.vue";
import ProjectProcess from "@/components/ProjectProcess.vue";

export default {
  name: "App",
  components: {
    SliderProjects,
    ProjectProcess,
  },
  data() {
    return {
      isVisible: false,
      slides: [
        {
          type: "text",
          content: "contentAnomala",
        },
        {
          type: "image",
          content: "/img/anomala/anomala1.png",
        },
        {
          type: "image",
          content: "/img/anomala/anomala2.png",
        },
        {
          type: "image",
          content: "/img/anomala/anomala3.png",
        },
        {
          type: "image",
          content: "/img/anomala/anomala5.JPG",
        },
        {
          type: "image",
          content: "/img/anomala/anomala4.png",
        },
        {
          type: "image",
          content: "/img/anomala/anomala6.JPG",
        },
      ],
      project: {
        title: "L'anòmala",
        work: "developerInteractive",
      },
      process: [
        {
          text: "procesAnomala1",
        },
        {
          text: "procesAnomala2",
        },
        {
          text: "procesAnomala3",
        },
      ],
      processInfo: [
        {
          title: "direction",
          subtitle: "Núria Jordán",
        },
        {
          title: "production",
          subtitle: "Tate Climent & Carla Jimenez",
        },
        {
          title: "directionPhoto",
          subtitle: "Maribel Serrano",
        },
        {
          title: "developer",
          subtitle: "Núria Jordán",
        },
        {
          title: "interactiveDesign",
          subtitle: "Tate Climent",
        },
        {
          title: "artDirection",
          subtitle: "Pau Sonet",
        },
        {
          title: "webDeveloper",
          subtitle: "Carla Jimenez",
        },
        {
          title: "graphicDesign",
          subtitle: "Pau Sonet & Marta Sánchez",
        },
      ],
      items: [
        {
          title: "L'anòmala",
          subtitle: "developerInteractive",
          url: "/anomala",
        },
        {
          title: "El Modern",
          subtitle: "developerInteractive",
          url: "/modern",
        },
        {
          title: "Wildtech",
          subtitle: "webDeveloper2",
          url: "/wildtech",
        },
        {
          title: "Sense",
          subtitle: "webDeveloper2",
          url: "/sense",
        },
        {
          title: "Broomx",
          subtitle: "webDeveloper2",
          url: "/broomx",
        },
        {
          title: "Units x Educar",
          subtitle: "webDeveloper2",
          url: "/units",
        },
      ],
      images: [
        "/img/anomala/anomala1.png",
        "/img/modern/modern1.png",
        "/img/wildtech/wildtechmenu2.png",
        "/img/sense/sensemenu.png",
        "/img/broomx/broomxmenu.png",
        "/img/units/unitsmenu.jpg",
      ],
      hoveredIndex: null,
      projectsVisible: false,
    };
  },
  methods: {
    processShow() {
      this.isVisible = !this.isVisible;
    },
    infoShow() {
      this.isVisible = !this.isVisible;
    },
    infoProjects() {
      this.projectsVisible = !this.projectsVisible;
      console.log(this.projectsVisible);
    },
    hideImage() {
      this.hoveredIndex = null;
    },
    showImage(index) {
      this.hoveredIndex = index;
    },
    getImageUrl(index) {
      return this.images[index];
    },
    handleWordClick(word) {
      if (word === "projectes") {
        this.projectsVisible = !this.projectsVisible;
        console.log(
          "Evento recibido: Se hizo clic en 'projectes'",
          this.projectsVisible
        );
      } else if (word === "mi") {
        this.isVisible = !this.isVisible;
        console.log("Evento recibido: Se hizo clic en 'mi'", this.isVisible);
      }
    },
  },
};
</script>

<style>
.background-variable {
  background-color: var(--background-color);
}
</style>

